import { BeltSyllabus } from './types';

export const greenBelt: BeltSyllabus = {
    id: 'green',
    name: 'Green Belt',
    color: '#008000',
    theoryUnder13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What does Won-Hyo mean?',
                    answer: 'Won-Hyo was the noted monk who introduced Buddhism to the Silla Dynasty in the year 686 AD'
                },
                {
                    question: 'How many movements in Won-Hyo?',
                    answer: '28'
                },
                {
                    question: 'What is the diagram of Won-Hyo?',
                    answer: '/assets/diagrams/won_hyo_diagram.png',
                    isImage: true
                },
                {
                    question: 'What does the colour of the Green Belt mean?',
                    answer: 'Green signifies the plant\'s growth as Taekwon-Do skills begin to develop'
                },
                {
                    question: 'What is the fifth tenet of Taekwon-Do?',
                    answer: 'Indomitable Spirit'
                },
                {
                    question: 'What does Indomitable Spirit mean?',
                    answer: 'Courage, to stand up in the face of adversity, to live to your principles even against insurmountable odds'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Fixed Stance', answer: 'Gojung Sogi' },
                { question: 'Closed Stance', answer: 'Moa Sogi' },
                { question: 'Elbow', answer: 'Palkup' },
                { question: 'Reverse Turning Kick', answer: 'Bandae Dollyo Chagi' },
                { question: 'Hooking Kick', answer: 'Golcho Chagi' },
                { question: 'Double Forearm Block', answer: 'Doo Palmok Makgi' },
                { question: 'Palm Hooking Block', answer: 'Sonbadak Golcho Makgi' },
                { question: 'Twin Fist Vertical Punch', answer: 'Sang Joomok Sewo Jirugi' },
                { question: 'X Fist Pressing Block', answer: 'Kyocha Joomok Noollo Makgi' },
                { question: 'Forward', answer: 'Nakagi' },
                { question: 'Backward', answer: 'Durogi' }
            ]
        }
    ],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Won-Hyo?',
                    answer: 'Won-Hyo was the noted monk who introduced Buddhism to the Silla Dynasty in the year 686 AD'
                },
                {
                    question: 'How many movements in Won-Hyo?',
                    answer: '28'
                },
                {
                    question: 'What is the diagram of Won-Hyo?',
                    answer: '/assets/diagrams/won_hyo_diagram.png',
                    isImage: true
                },
                {
                    question: 'What does the Green Belt signify?',
                    answer: 'Green signifies the plant\'s growth as Taekwon-Do skills begin to develop'
                },
                {
                    question: 'What is Connecting Motion?',
                    answer: 'Techniques performed in Connecting Motion (Yon-Gyol Tongjak) are performed with no pause between techniques, only one breath and with both techniques performed during the same Sine Wave. Connecting Motion is always performed with two techniques using opposite arms. One reason for Connecting Motion is to use one technique to "set up" an opponent for an immediate attack.'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'X Stance', answer: 'Kyocha Sogi' },
                { question: 'Closed Stance', answer: 'Moa Sogi' },
                { question: 'Close Ready Stance', answer: 'Moa Junbi Sogi' },
                { question: 'Side Sole', answer: 'Yop Balbadak' },
                { question: 'Side Instep', answer: 'Yop Baldung' },
                { question: 'Reverse Turning Kick', answer: 'Bandae Dollyo Chagi' },
                { question: 'Hooking Kick', answer: 'Golcho Chagi' },
                { question: 'Double Forearm Block', answer: 'Doo Palmok Makgi' },
                { question: 'Palm Hooking Block', answer: 'Sonbadak Golcho Makgi' },
                { question: 'Twin Fist Vertical Punch', answer: 'Sang Joomok Sewo Jirugi' },
                { question: 'X Fist Pressing Block', answer: 'Kyocha Joomok Noollo Makgi' },
                { question: 'Sidefist Downward Strike', answer: 'Yop Joomok Naeryo Taerigi' },
                { question: 'Outward Waist Block', answer: 'Bakat Hori Makgi' },
                // Note: Hooking Kick appeared twice in the source list, included once here.
                { question: 'Two-Step Sparring', answer: 'Ibo Matsogi' },
                { question: 'Free Sparring', answer: 'Jayoo Matsogi' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'Walking Stance Double Forearm High Block',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Walking Stance Obverse Palm Hooking Block, Reverse Palm Hooking Block, Obverse Middle Punch (Connecting Motion)',
                    answer: 'Forward X 4'
                },
                {
                    question: 'X Stance Backfist High Side Strike',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Hooking Kick (Front Leg), Turning Kick (Rear Leg)',
                    answer: 'Forward X 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Left and Right Leg Side Piercing Kick',
                    answer: '1 Board'
                },
                {
                    question: 'Reverse Turning Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Do-San',
                    answer: ' '
                },
                {
                    question: 'Won-Hyo',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'Being Held with Back against a Wall',
                    answer: 'All Ages'
                },
                {
                    question: 'Shoulder Tap / Grab from Behind (Either Hand / Shoulder)',
                    answer: 'All Ages'
                },
                {
                    question: 'Situational - Straight Punch(es)',
                    answer: 'All Ages'
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'Two-Step Sparring',
                    answer: 'Sequences 1-3'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Blocking Only'
                }
            ]
        }
    ]
};
